import api from './api';

export const userService = {
  // Dohvati sve korisnike
  getAllUsers: async (page = 1, limit = 10) => {
    return await api.get(`/users?page=${page}&limit=${limit}`);
  },

  // Dohvati korisnika po ID-u
  getUserById: async (id) => {
    return await api.get(`/users/${id}`);
  },

  // Kreiraj novog korisnika
  createUser: async (userData) => {
    return await api.post('/users', userData);
  },

  registerUserViaLink: async (registrationData) => {
   const response = await api.post('/users/register-via-link', registrationData);
   return response;
  },

  // Ažuriraj korisnika
  updateUser: async (id, userData) => {
    return await api.put(`/users/${id}`, userData);
  },

  // Obriši korisnika
  deleteUser: async (id) => {
    return await api.delete(`/users/${id}`);
  },

  // Dohvati korisnike po tenant-u
  getUsersByTenant: async (tenantId, page = 1, limit = 10) => {
    return await api.get(`/users/tenant/${tenantId}?page=${page}&limit=${limit}`);
  },

  // Dohvati korisnike po tipu
  getUsersByType: async (userType, page = 1, limit = 10) => {
    return await api.get(`/users/type/${userType}?page=${page}&limit=${limit}`);
  },
};

export default userService;





